import { ChangeAddressComponent } from '../../../components/forms/dynamic-forms/profile-settings-forms/change-address/change-address.component';
import { MapfreCardComponent } from '../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { AddressInputService } from '../../../_services/forms/change-address/change-address.service';
import { AddressService } from '../../../_services/change-address/validate-address.service';
import { PolicyDataService } from '../../../_services/data-services/policy-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, ChangeAddressComponent],
  selector: 'app-address-change',
  templateUrl: './address-change.component.html',
  providers: [AddressInputService],
})
export class AddressChangeComponent implements OnInit {
  inputs: any[];
  addressType: string;
  loading = false;
  typeOfAddress: string;
  policyId: string;
  address: any;
  lable: string;
  policyStateCode: string;
  policyData: any;
  isAcmic = false;
  policies: any;
  constructor(
    private service: AddressInputService,
    private activatedRoute: ActivatedRoute,
    private validateAddressService: AddressService,
    private policyDataService: PolicyDataService,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    let streetAddress: any = [];
    this.address = this.validateAddressService.getAddress();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.addressType = params['address-type'];
      this.policyId = params['policyid'];
    });
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policies=policyResponse;
        const currentPolicyData = policyResponse.find(
          (policy) => policy.policynumber.policyNumber === this.policyId
        );
        if (currentPolicyData) {
          this.policyData = currentPolicyData;
          this.policyStateCode = currentPolicyData.jurisdiction.state;
        }
      }
    });
    if (this.addressType == 'mailing') {
      this.lable = 'Mailing address';
    } else if (this.addressType == 'residential') {
      this.lable = 'Residential address';
    }
    if (this.address != undefined) {
      streetAddress = this.address.streetName.includes('|')
        ? this.address.streetName.split('|')
        : this.address.streetName.split('#');
      const apartment =
        streetAddress && streetAddress.length > 1 ? streetAddress[1] : '';
      this.inputs = this.service.getInputs(
        '',
        `${streetAddress[0]}, ${this.address.city}, ${this.address.state}, USA`,
        apartment,
        this.lable,
        this.policyId,
        this.addressType
      );
    }
    if (this.addressType == 'mailing') {
      this.typeOfAddress = 'UPDATE_MAILING_ADD';
    } else if (this.addressType == 'residential') {
      this.typeOfAddress = 'CHANGE_ADDRESS_RESIDENTIAL';
    }
  }
}
